import { useCallback, useMemo } from "react";
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";

import { WithConfiguration } from "Components/Generic/Configuration";
import { WithTranslator } from "Components/Generic/Translator";
import { IProviderProps } from "./IProviderProps";

export const Provider = WithConfiguration(
  WithTranslator((props: IProviderProps): JSX.Element => {
    const {
      className, onChange, config, translator
    } = props;

    const onProviderChange = useCallback(
      (_, option?: IDropdownOption<string>) => {
        if (option == null) {
          return;
        }

        const { key } = option;
        onChange(key as string);
      },
      [onChange]
    );

    const options: IDropdownOption<string>[] = useMemo(
      () => config.getProviderSync().map(([key, text]) => {
        const title = `${translator.get(`provider.${text.toLowerCase()}`, text)} (${key})`;
        return {
          key,
          text: title,
          title
        };
      }),
      [config, translator]
    );

    return (
      <Dropdown
        className={className}
        placeholder={`${translator.get(`settings.sync.providercode`, `Select an option`)}...`}
        onChange={onProviderChange}
        options={options}
      />
    );
  })
);
